import { GQLContentForm } from "@quales/data-access/graphql";
import lodash from "lodash";
import { GetFormSchemaPath } from "./GetFormSchemaPath";

export const GetFormStateAfterPropertiesChange = (
  item: any,
  formContent: GQLContentForm,
  selectedNode: any
) => {
  if (item && item.name === "root") {
    let newFormSchemaItem = lodash.cloneDeep(formContent.formSchema);

    if (newFormSchemaItem === null || newFormSchemaItem === undefined) {
      newFormSchemaItem = item.formSchema;
      return newFormSchemaItem;
    } else {
      newFormSchemaItem.title =
        (item && item.formSchema && item.formSchema.title) || "";
      newFormSchemaItem.description = item.formSchema.description;
      if (item.formSchema.required && item.formSchema.required.length > 0) {
        newFormSchemaItem.required = item.formSchema.required;
      }

      const returnSelectedItem = {
        ...selectedNode,
        ...item,
      };
      return {
        selectedNode: returnSelectedItem,
        formContentItem: {
          formSchema: newFormSchemaItem,
          uiSchema: item.uiSchema,
        },
      };
    }
  } else {
    const newUiSchema = lodash.cloneDeep(formContent.uiSchema);
    const newFullObject = lodash.cloneDeep(formContent);
    const formItemPath = GetFormSchemaPath(item.name, newFullObject);
    delete item.name;
    let oneOf = [];
    if (item.type !== "array") {
      // if (item.type === "boolean" && item.uiSchema["ui:widget"]) {
      //   oneOf = [
      //     { const: true, title: item.oneOfTrueLabel || "" },
      //     { const: false, title: item.oneOfFalseLabel || "" },
      //   ];
      // }
      if (
        item.type === "string" &&
        item.uiSchema &&
        item.uiSchema["ui:widget"] &&
        item.uiSchema["ui:widget"] === "ThreeSegmentedButtonsWidget"
      ) {
        oneOf = [
          {
            const:
              (item.formSchema.oneOf &&
                item.formSchema.oneOf[0] &&
                item.formSchema.oneOf[0].const) ||
              "true",
            title:
              (item.formSchema.oneOf &&
                item.formSchema.oneOf[0] &&
                item.formSchema.oneOf[0].title) ||
              "true",
          },

          {
            const:
              (item.formSchema.oneOf &&
                item.formSchema.oneOf[1] &&
                item.formSchema.oneOf[1].const) ||
              "na",
            title:
              (item.formSchema.oneOf &&
                item.formSchema.oneOf[1] &&
                item.formSchema.oneOf[1].title) ||
              "na",
          },
          {
            const:
              (item.formSchema.oneOf &&
                item.formSchema.oneOf[2] &&
                item.formSchema.oneOf[2].const) ||
              "false",
            title:
              (item.formSchema.oneOf &&
                item.formSchema.oneOf[2] &&
                item.formSchema.oneOf[2].title) ||
              "false",
          },
        ];
      }
      if (
        item.type === "string" &&
        item.uiSchema &&
        item.uiSchema["ui:widget"] &&
        item.uiSchema["ui:widget"] === "ThreeSegmentedIconButtonsWidget"
      ) {
        oneOf = [
          {
            const: "true",
            title: "Goed",
            icon: "check",
            color: "#74B816",
          },

          {
            const: "false",
            title: "Niet goed",
            color: "#FA5252",
            icon: "close",
          },
          {
            const: "na",
            title: "n.v.t",
            color: "#868E96",
            icon: "block",
          },
        ];
      }
      if (oneOf && oneOf.length > 0) {
        lodash.setWith(
          newFullObject.formSchema,
          formItemPath,
          {
            ...item.formSchema,
            oneOf: oneOf && oneOf.length > 0 ? oneOf : undefined,
            format: item.format,
          },
          Object
        );
      } else {
        lodash.setWith(
          newFullObject.formSchema,
          formItemPath,
          {
            ...item.formSchema,
          },
          Object
        );
      }

      const oldUiSchema = lodash.get(
        formContent.uiSchema,
        selectedNode.uiSchemaPath
      );
      lodash.set(newUiSchema, selectedNode.uiSchemaPath, {
        ...oldUiSchema,
        "ui:options":
          item.uiSchema && item.uiSchema["ui:options"]
            ? item.uiSchema["ui:options"]
            : undefined,

        "ui:widget":
          item.uiSchema && item.uiSchema["ui:widget"]
            ? item.uiSchema["ui:widget"]
            : undefined,
      });
    } else {
      lodash.setWith(
        newFullObject.formSchema,
        formItemPath,
        {
          ...item.formSchema,
          title: item.title,
          items: {
            ...item.formSchema.items,
          },
          type: item.type,
          format: item.format,
        },
        Object
      );

      if (!item.uiField) {
        delete item.uiField;
      }

      lodash.set(newUiSchema, selectedNode.uiSchemaPath, {
        "ui:field": item.uiField,
        "ui:options":
          item.uiSchema && item.uiSchema["ui:options"]
            ? item.uiSchema["ui:options"]
            : undefined,
      });
    }
    const returnSelectedItem = {
      ...selectedNode,
      oneOf: oneOf && oneOf.length > 0 ? oneOf : undefined,
      ...item,
    };
    return {
      selectedNode: returnSelectedItem,
      formContentItem: {
        uiSchema: newUiSchema,
        formSchema: newFullObject.formSchema,
      },
    };
  }
};
